import { JobReview } from '@csh/ui/api/types/jobReview';
import React from 'react';

export interface UpdateJobReviewModalProps {
  isOpen: boolean;
  toggle: () => void;
  item: JobReview;
}

export const UpdateJobReviewModal: React.FunctionComponent = () => {
  return <></>;
};
